import { createSelector } from 'reselect'

const featureRootSelector = ({ scheduling }) => scheduling

const eventTypesSelector = createSelector(
  featureRootSelector,
  ({ eventTypes }) => eventTypes
)

export const eventTypeSelector = (id) => createSelector(
  eventTypesSelector,
  (eventTypes) => eventTypes.find(({ id: i }) => i === id)
)

export const visibleEventTypesSelector = createSelector(
  featureRootSelector,
  eventTypesSelector,
  ({ visibleEventTypeIds }, eventTypes) => eventTypes.filter(({ id }) => visibleEventTypeIds.includes(id))
)

export const selectedEventTypeIdsSelector = createSelector(
  featureRootSelector,
  ({ selectedEventTypeIds }) => selectedEventTypeIds
)

export const lastSelectedEventTypeSelector = createSelector(
  featureRootSelector,
  ({ lastSelectedEventType }) => lastSelectedEventType
)

export const selectableEventTypesSelector = createSelector(
  visibleEventTypesSelector,
  (eventTypes) => eventTypes.filter(({ policy: { edit } }) => edit)
)

export const deleteConfirmationPopupOpenSelector = createSelector(
  featureRootSelector,
  ({ deleteConfirmationPopupOpen }) => deleteConfirmationPopupOpen
)

export const selectedEventTypesSelector = createSelector(
  eventTypesSelector,
  selectedEventTypeIdsSelector,
  (eventTypes, ids) => eventTypes.filter(({ id }) => ids.includes(id))
)

export const canImportAvailabilitySelector = createSelector(
  selectedEventTypesSelector,
  (eventTypes) => {
    if (eventTypes.length === 0) return false

    const importAllowed = eventTypes.every(({ owner_type: ownerType, kind }) => {
      if (kind === 'group') return false
      if (ownerType === 'User') return false
      if (ownerType === 'Organization') return false

      return true
    })

    if (!importAllowed) return false

    const sameOwner = [...new Set(eventTypes.map(({ owner_id: ownerId }) => ownerId))].length === 1 // there's no uniq in JS
    if (!sameOwner) return false

    return true
  }
)

export const exportDelayedPopupOpened = createSelector(
  featureRootSelector,
  ({ exportDelayedPopup }) => exportDelayedPopup.open
)
